import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Input, Button, Select, Tooltip, message } from "antd";
import { ClockCircleOutlined, InfoCircleFilled } from '@ant-design/icons';
import Country from 'country-data';

import { statusIncomplete, renderCountries, getFields, statusInfo } from "./Utils";
import Header from './header'
import UserActions from "../../actions/UserAction";
import { putUserPhoneDetail, getUserVerify, getSmsCode } from '../../common/fetch';
import { OperatorFormWrapper } from './style';

const { Item } = Form;


const PhoneVerification = ({ form, exchange, verifyStatus, setVerifyStatus, user }) => {

    const { getFieldsValue, validateFields } = form;
    const { phone_number, country_field, sms } = getFieldsValue();
    const [smsValue, setSmsValue] = useState('Send');
    const [smsCode, setSmsCode] = useState('');
    const [phoneNumErrorMsg, setPhoneNumErrorMsg] = useState('');
    const [smsCodeErrorMsg, setSmsCodeErrorMsg] = useState('');
    const [codeExpireTime, setCodeExpireTime] = useState(40);
    const [isShowExpireTime, setIsShowExpireTime] = useState(false);
    const [countryInitialValue, setCountryInitialValue] = useState('');
    const [countryCallingCode, setCountryCallingCode] = useState('');

    useEffect(() => {
        let reverseNumber = [];
        let straitNumber = [];
        let number = [];
        let countryCodeArray = [];
        let countryCode = '';
        let countryArray = [];
        let countryAlpha = '';
        user.phone_number.split('').forEach((code, index) => {
            if (reverseNumber.length !== 10 && user.phone_number[user.phone_number.length - index] !== undefined) {
                reverseNumber.push(user.phone_number[user.phone_number.length - index])
            }
            if (reverseNumber.length === 10) {
                countryCodeArray.push(user.phone_number[user.phone_number.length - index - 1])
            }
        });
        reverseNumber.forEach((num, index) => {
            straitNumber.push(reverseNumber[reverseNumber.length - index - 1]);
        });
        countryCodeArray.forEach((num, index) => {
            number.push(countryCodeArray[countryCodeArray.length - index - 1]);
        })
        countryCode = number.join('');
        countryArray = Object.entries(Country.countries).filter(([key, value]) => (value.countryCallingCodes && value.countryCallingCodes[0] === countryCode));
        countryAlpha = countryArray && countryArray[0] && countryArray[0][0];
        setCountryInitialValue(countryAlpha);
        setSmsCode(straitNumber.join(''));
        if (countryAlpha) {
            setCountryCallingCode(countryAlpha && Country.countries[countryAlpha].countryCallingCodes[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.phone_number])

    const onHandleSmsCode = async () => {
        if (smsValue === 'Send') {
            setSmsValue('Connecting...')
            try {
                const res = await getSmsCode({ phone: `${countryCallingCode}${smsCode}` }, exchange[0].id);
                if (res.data.message) {
                    setIsShowExpireTime(true);
                    setSmsValue('Send');
                    message.success(res.data.message);
                    let count = 40;
                    const countdown = setInterval(() => {
                        count--;
                        setCodeExpireTime(count);
                        if (count === 0) {
                            clearInterval(countdown);
                            setIsShowExpireTime(false);
                        }
                    }, 1000);
                }
            } catch (error) {
                setPhoneNumErrorMsg(error ? `Error sending the SMS to ${countryCallingCode} ${phone_number}. Please refresh the page and try again.` : '');
            }
        }
    }

    const suffixContent = () => {
        return (
            <div className={`send-sms ${verifyStatus.phone === 3 || !smsCode || !countryCallingCode ? 'pointer-none' : ''} ${smsValue !== 'Send' ? 'display-none' : ''}`}>
                <div onClick={onHandleSmsCode}>{smsValue}</div>
            </div>
        )
    }

    const prefixContent = () => {
        return (
            <div className="country-calling-code">{countryCallingCode}</div>
        )
    }

    const onHandlePhoneVerificationSubmit = (e) => {
        e.preventDefault();
        validateFields(async (err, values) => {
            const { phone_number } = values
            if (!err) {
                try {
                    const res = await putUserPhoneDetail({ phone: `${countryCallingCode}${phone_number}`, code: sms }, exchange[0].id)
                    setVerifyStatus({ ...verifyStatus, phone: 4 })
                    if (res && res.data) {
                        const getuserData = 'getCall'
                        getuserData && setVerifyStatus({ ...verifyStatus, phone: 3 })
                        setSmsCodeErrorMsg('');
                        setIsShowExpireTime(false);
                    }
                } catch (error) {
                    setSmsCodeErrorMsg('The code provided is invalid');
                }
            }
        });
    }

    return (
        <Form onSubmit={onHandlePhoneVerificationSubmit} className={`phone-verfication-wrapper ${(verifyStatus.phone === 3 || verifyStatus.phone === 4) && 'form-disable'}`}>
            <Item>
                <h3>Phone verification</h3>
                <p>Providing your personal phone contact details and verify through an SMS code.</p>
            </Item>
            <Item>
                <div className="d-flex align-center">
                    <h4>Country</h4>
                    <Tooltip title='Input your country' placement="right"><InfoCircleFilled style={{ color: '#ffffff' }} /></Tooltip>
                </div>
                {getFields(form, 'country_field', 'Required Country', countryInitialValue || 'Select country')(<Select
                    optionFilterProp="children"
                    showSearch
                    onChange={(e) => setCountryCallingCode(Country.countries[e].countryCallingCodes[0])}>
                    <Select.Option value="">Global</Select.Option>
                    {renderCountries()}
                </Select>)}
            </Item>
            <Item className="phone-container">
                <div className="d-flex align-center">
                    <h4>Phone number</h4>
                    <Tooltip title={`Click 'SEND' to get a code to verify your number`} placement="right"><InfoCircleFilled style={{ color: '#ffffff' }} /></Tooltip>
                </div>
                <div className={`d-flex phone-number-message ${phoneNumErrorMsg ? 'error-wrapper' : ''}`}>
                    {getFields(form, 'phone_number', 'Required Phone number', smsCode)(<Input className="sms-code"
                        onChange={(e) => setSmsCode(e.target.value)}
                        placeholder="Input number"
                        filterOption
                        suffix={suffixContent()}
                        prefix={prefixContent()} />)
                    }
                    <div className="error-msg-container" style={{ padding: phoneNumErrorMsg ? '0 0.5rem' : '' }}>{phoneNumErrorMsg}</div>
                </div>
            </Item>
            <Item>
                <div className="d-flex align-center">
                    <h4>SMS Code</h4>
                    <Tooltip title='Input the code sent to you below' placement="right"><InfoCircleFilled style={{ color: '#ffffff' }} /></Tooltip>
                </div>
                <div className="d-flex sms-message-wrapper">
                    {getFields(form, 'sms', 'Required SMS Code')(<Input placeholder="Input your SMS code" />)}
                    {smsCodeErrorMsg && <div className="error-msg-container" style={{ padding: smsCodeErrorMsg ? '0 0.5rem' : '' }}>{smsCodeErrorMsg}</div>}
                    {isShowExpireTime && <div className="error-msg-container time-container">Code expires in<span className="sub-content">{codeExpireTime} seconds <ClockCircleOutlined /></span></div>}
                </div>
            </Item>
            {verifyStatus.phone !== 3 && <Button type="primary" className="submit-btn" htmlType="submit" disabled={!phone_number || !sms || sms.length < 6 || !country_field}>
                Submit
            </Button>
            }
        </Form>
    )
}

/* eslint-disable */
const PhoneVerificationForm = Form.create()(PhoneVerification);
/* eslint-enable */

const IdentityForm = ({ exchange, verifyStatus, setVerifyStatus, status, user }) => {
    if (!status) {
        status = 0
    }

    const onHandleVerificationSubmit = async () => {
        try {
             const res = await getUserVerify(exchange[0].id);
            res && res.data && setVerifyStatus({ ...verifyStatus, identity: user && user.id_data && user.id_data.status })
            window.open(res.data.url);
        } catch (err) {
             message.error(err.data.message, 5);
        }
    }

    return (
        <Form className={status === 3 && 'form-disable'}>
            <Item>
                <h3>Proof of identity</h3>
                <div className="proof-of-identity-content">
                    <p>Provide documentation and other proof of your identity.</p>
                    <p>To start your identity check please click the button below.</p>
                    <p>Processing of your ID documentation can take on average 20 minutes.</p>
                </div>
            </Item>
            <Item>
                <p>Note: You will be redirected to an automated electronic ID processing flow</p>
            </Item>
            <Button type="primary" className="submit-btn" onClick={() => onHandleVerificationSubmit()} disabled={status === 3}>
                Start identity verification
            </Button>
        </Form>
    )
}

const IdentityFieldForm = Form.create()(IdentityForm);

const Operator = ({ activeTab, setActiveTab, exchange, verifyStatus, setVerifyStatus, status, user, readUser, handleComplete }) => {
    const { identity: identityVerify } = verifyStatus;
    const [setIsResubmission] = useState(false)
    let nameStatus, identityStatus;

    if (identityVerify === 3) {
        identityStatus = 3;
    } else if (identityVerify === 1) {
        identityStatus = 4; 
    } else if (identityVerify === 2) {
        identityStatus = 0;
    } else {
        identityStatus = 1;
    }

    const onHandleHere = () => {
        setVerifyStatus({ ...verifyStatus, name: nameStatus === 3 ? 3 : 0, phone: 3, identity: identityStatus === 3 ? 3 : 0 });
        setIsResubmission(true);
    }

    return (
        <div className="operator-wrapper">
            <Header setActiveTab={setActiveTab} handleComplete={handleComplete} onHandleHere={onHandleHere} activeTab={activeTab} img={'operator'} />
            <OperatorFormWrapper>
                <div className={`operator-form-wrapper`}>
                    {/* <div className="d-flex">
                        <div className="section-wrapper">
                            <PhoneVerificationForm
                                verifyStatus={verifyStatus}
                                exchange={exchange}
                                setVerifyStatus={setVerifyStatus}
                                user={user}
                            />
                        </div>
                        {statusIncomplete(statusInfo[phoneVerify])}
                    </div> */}
                    <div className="d-flex">
                        <div className="section-wrapper">
                            <IdentityFieldForm
                                exchange={exchange}
                                verifyStatus={verifyStatus}
                                setVerifyStatus={setVerifyStatus}
                                status={status}
                                user={user}
                            />
                        </div>
                        {statusIncomplete(statusInfo[identityStatus])}
                    </div>
                </div>
            </OperatorFormWrapper>
        </div>
    )
}

const mapStateToProps = (store) => {
    return {
        phone_number: store.user.phone_number,
        status: store.user.id_data.status,
        user: store.user,
        exchange: store.exchange
    }
}

const mapDispatchToProps = (dispatch) => ({
    readUser: bindActionCreators(UserActions.readData, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Operator);